import { getMinimumOrderValues } from 'redux/modules/trolley/actions/get-minimum-order-values';
import { getAreMinimumOrderValuesLoaded } from 'redux/modules/trolley/selectors/get-are-minimum-order-values-loaded';

export const minimumOrderValuesFetcher = () => (dispatch, getState) =>
  getAreMinimumOrderValuesLoaded(getState())
    ? Promise.resolve()
    : dispatch(getMinimumOrderValues());
